import { Injectable } from '@angular/core';
import { isArray } from '@core/helpers';
import { AbstractAsyncTaskReport } from './abstract-async-task.report';
import { ITask } from './async-task-constants';

@Injectable({
  providedIn: 'root'
})
export class EntityBulkCloseReport extends AbstractAsyncTaskReport {
    public generate(task: ITask): string {
        if (task.status === 'success') {
          return `<div>Fermeture en masse des entités réussie.</div>`;
        } else {
          let htmlDetail = `<div>Échec de la fermeture en masse des entités.<br></div>`;
          htmlDetail += this.EntityBulkCloseImportError(task.detail);
          return htmlDetail;
        }
      }

    private EntityBulkCloseImportError(detail): string {
        if (!detail || !Object.keys(detail).length) {
            return '';
        }
        let errorString = '<ul>';
        detail.forEach(error => {
            errorString += '<li>';
            switch (error.error_type) {
              case 'INVALID_FILE_STRUCTURE':
                errorString += `Structure du fichier importé invalide :<br>`;
                if (error.error_detail && isArray(error.error_detail)) {
                  errorString += `<ul><li>`;
                  errorString += error.error_detail.join('</li>\n<li>');
                  errorString += `</li></ul>`;
                }
                break;
              case 'INVALID_FILE_CONTENT':
                errorString += `Certains codes d'entité n'ont pas passé l'étape de validation.`;
                errorString += `
                  <br><br>
                  <a href="${this.apiShiva.attachments.downloadUrl(error.attachment_id)}" class="btn btn-default" target="_blank">
                    <i class="far fa-file-excel" aria-hidden="true"></i>
                    Télécharger le rapport
                  </a>
                `;
                break;
              case 'ENTITY_NOT_CLOSABLE':
                errorString += `Certaines entités ne peuvent pas être fermées en l'état.`;
                errorString += `
                  <br><br>
                  <a href="${this.apiShiva.attachments.downloadUrl(error.attachment_id)}" class="btn btn-default" target="_blank">
                    <i class="far fa-file-excel" aria-hidden="true"></i>
                    Télécharger le rapport
                  </a>
                `;
                break;
              default:
                errorString += 'Erreur non reconnue.';
                break;
            }
            errorString += '</li>';
        });
        errorString += '</ul>';
        return errorString;
    }
}
